export const continueFromSelectBitesDataSet = { cy: 'continue-from-add-bites' };
